import { NumberFormatCustom, NumberFormatCustomProps } from '@lfg/ui/components';
import { Box, Typography } from '@mui/material';
import { forwardRef } from 'react';

import { colors } from 'src/global/styles/colors';

import { AdminInput } from './AdminTextField';

interface IProps extends NumberFormatCustomProps {
  isError?: boolean;
  errorMsg?: string;
}

export const AdminNumberFormat = forwardRef((props: IProps, ref: React.Ref<HTMLInputElement>) => {
  const { isError, errorMsg, value, onChange, readOnly, ...rest } = props;
  return (
    <Box>
      <NumberFormatCustom
        ref={ref}
        focusedBorderColor='white'
        borderColor={isError ? colors.error : !value ? colors.neutral015 : 'transparent'}
        style={{
          width: '100%',
        }}
        thousandSeparator={true}
        customInput={AdminInput as any}
        value={Number(value)}
        placeholder='0%'
        suffix='%'
        readOnly={readOnly}
        {...rest}
      />
      {isError ? (
        <Typography paddingTop={1} color={colors.error} fontSize={'14px'}>
          {errorMsg}
        </Typography>
      ) : null}
    </Box>
  );
});
